export type StartupErrorKind = 'network' | 'forbidden' | 'server' | 'unknown';

export interface StartupError {
  kind: StartupErrorKind;
  message: string;
  requestId?: string;
}

const getStatus = (error: unknown): number | undefined => {
  if (typeof error === 'object' && error !== null) {
    const status = (error as { status?: unknown }).status;
    if (typeof status === 'number') return status;
  }
  return undefined;
};

const getRequestId = (error: unknown): string | undefined => {
  if (typeof error === 'object' && error !== null) {
    const requestId = (error as { requestId?: unknown }).requestId;
    if (typeof requestId === 'string' && requestId) return requestId;
  }
  return undefined;
};

export const formatErrorRef = (requestId?: string): string | null =>
  requestId ? requestId.replace(/-/g, '').slice(0, 8).toUpperCase() : null;

export const classifyStartupError = (error: unknown): StartupError => {
  const status = getStatus(error);
  const requestId = getRequestId(error);

  if (status === undefined) {
    return {
      kind: 'network',
      message: "Can't reach the server — it may be offline.",
      requestId
    };
  }
  if (status === 403) {
    return {
      kind: 'forbidden',
      message: "Some data couldn't be loaded — you may not have access to it.",
      requestId
    };
  }
  if (status >= 500) {
    return {
      kind: 'server',
      message: 'The server had a problem loading your data.',
      requestId
    };
  }
  return {
    kind: 'unknown',
    message: 'Something went wrong loading your data.',
    requestId
  };
};
